<template>
  <CHeader fixed with-subheader light>
    <CToggler
      in-header
      class="ml-3 d-lg-none"
      @click="$store.commit('toggleSidebarMobile')"
    />
    <CToggler
      in-header
      class="ml-3 d-md-down-none"
      @click="$store.commit('toggleSidebarDesktop')"
    />
    <CHeaderBrand class="mx-auto d-lg-none" to="/">
      <!-- <CIcon name="logo" height="48" alt="Logo"/> -->
      INTERNAL-DEV
    </CHeaderBrand>
    <CHeaderNav class="d-md-down-none mr-auto">
      <!-- <CHeaderNavItem class="px-3">
        <CHeaderNavLink to="/dashboard">
          Dashboard
        </CHeaderNavLink>
      </CHeaderNavItem> -->
    </CHeaderNav>
    <CHeaderNav class="mr-4">
      <!-- <CHeaderNavItem class="d-md-down-none mx-2">
        <CHeaderNavLink>
          <CIcon name="cil-bell"/>
        </CHeaderNavLink>
      </CHeaderNavItem>
      <CHeaderNavItem class="d-md-down-none mx-2">
        <CHeaderNavLink>
          <CIcon name="cil-list"/>
        </CHeaderNavLink>
      </CHeaderNavItem>
      <CHeaderNavItem class="d-md-down-none mx-2">
        <CHeaderNavLink>
          <CIcon name="cil-envelope-open"/>
        </CHeaderNavLink>
      </CHeaderNavItem> -->
      <TheHeaderDropdownAccnt/>
    </CHeaderNav>
    <CSubheader class="px-3">
      <CBreadcrumbRouter class="border-0 mb-0"/>
    </CSubheader>
  </CHeader>
</template>

<script>
import TheHeaderDropdownAccnt from './TheHeaderDropdownAccnt'
import axios from "axios";
import jwt from 'jsonwebtoken';

export default {
  name: 'TheHeader',
  components: {
    TheHeaderDropdownAccnt
  },
   data () {
    return {
     accountData: {},
      domain: process.env.VUE_APP_DOMAIN_URL,
      token: "Bearer "+localStorage.getItem("token"),
    }
  },
   mounted () {
     const data = jwt.decode(localStorage.getItem("token"))
     if(data === null){
       this.$router.push({path: `/pages/login`})
     }else{
      axios
     .get(`${this.domain}/v1/account/${data.account_id}`, {
                headers: {
                    Authorization: this.token,
                    "Content-Type": "application/json",
                }
            })
    .then(response => {
      // JSON responses are automatically parsed.
      this.accountData = response.data
    })
    .catch(() => {
    })
     }
     
    },
  computed: {
    fields () {
      return [
        { key: 'key', label: this.username, _style: 'width:150px'},
        { key: 'value', label: '', _style: 'width:150px;' }
      ]
    },
  },
  methods: {
    
  }
}


</script>
